import { cn } from "cn";
import Link from "next/link";
import type { NavItem } from "@/data/routes";
import { externalLinkProps } from "@/lib/utils";

interface NavLinkProps extends Omit<React.ComponentProps<typeof Link>, "href"> {
  iconClassName?: string;
  item: NavItem;
}

export function NavLink({
  item,
  iconClassName,
  className,
  ...props
}: NavLinkProps) {
  return (
    <Link
      className={cn("flex items-center font-medium", className)}
      href={item.href}
      {...externalLinkProps(item.href)}
      {...props}
    >
      <item.icon
        aria-hidden="true"
        className={cn("size-5", iconClassName)}
        mode="raw"
      />
      <span>{item.label}</span>
    </Link>
  );
}
